var exports = {
  "Qs": "x804f0401--fd72d7--content",
  "UU": "x804f0401--fd72d7--name",
  "DD": "x804f0401--fd72d7--title",
  "VA": "x804f0401--fd72d7--subtitle",
  "uW": "x804f0401--fd72d7--section",
};

module.exports = exports;
